

const state = {
    
    blocks:[
        {
            id:1,
            name: 'Treatments',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formdatatable',
                            attributes: {
                                placeholder:"Treatments",
                                size:"xs10",
                                invertedsize:"xs1",                                
                                icon:"search",                                
                                setter: 'treatments/TREATMENT_SET_TREATMENT',                                    
                                items:'treatments/treatments',
                                withcheck:false,
                                withsearch:true,
                                withdialog:false,
                                headers: [
                                    {
                                        text: 'Name',
                                        value: 'name',
                                        sortable:false
                                    },    
                                    
                                ]
                            }                                    
                        }
                    ],                   
                ]
            },
        },
        
    ]
    
};

export default {
  namespaced: false,
  state,
  
};